import { DESIGN_SYSTEM_COLORS } from '../../constants';
import { Typography } from '../../TSTypes/typography';

const typography: Typography = {
  body: {
    backgroundColor: DESIGN_SYSTEM_COLORS.grayscale[900],
    color: DESIGN_SYSTEM_COLORS.grayscale[800],
    font: '"IBM Plex Sans", sans-serif',
    fontWeight: '400',
    size: {
      xsm: {
        fontSize: '10px',
      },
      sm: {
        fontSize: '12px',
      },
      md: {
        fontSize: '14px',
      },
    },
  },
  header: {
    type: {
      h1: {
        fontWeight: '600',
        fontSize: '24px',
        color: DESIGN_SYSTEM_COLORS.grayscale[800],
      },
      h2: {
        fontWeight: '500',
        fontSize: '20px',
        color: DESIGN_SYSTEM_COLORS.grayscale[800],
      },
      h3: {
        fontWeight: '600',
        fontSize: '18px',
        color: DESIGN_SYSTEM_COLORS.blue[650],
      },
      h4: {
        fontWeight: '500',
        fontSize: '16px',
        color: DESIGN_SYSTEM_COLORS.grayscale[800],
      },
    },
  },
};

export default typography;
